import {
  Component,
  input,
  output,
  HostListener,
  signal,
  computed,
} from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * 무한 스크롤 컨테이너 컴포넌트
 *
 * @example
 * <app-infinite-scroll
 *   [hasMore]="hasMore()"
 *   [isLoading]="isLoading()"
 *   (loadMore)="loadMore()">
 *   @for (item of items(); track item.id) {
 *     <div>{{ item.name }}</div>
 *   }
 * </app-infinite-scroll>
 */
@Component({
  selector: 'app-infinite-scroll',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="infinite-scroll-container">
      <ng-content></ng-content>

      @if (showLoading()) {
      <div class="flex justify-center py-6">
        <span class="loading loading-spinner loading-md text-primary"></span>
      </div>
      }
    </div>
  `,
  styles: [
    `
      .infinite-scroll-container {
        display: flex;
        flex-direction: column;
        gap: 1rem;
      }
    `,
  ],
})
export class InfiniteScrollComponent {
  /** 더 불러올 데이터가 있는지 */
  hasMore = input<boolean>(false);

  /** 현재 로딩 중인지 */
  isLoading = input<boolean>(false);

  /** 스크롤 임계값 (px) - 하단에서 이 거리 이내일 때 로드 */
  threshold = input<number>(200);

  /** 더 불러오기 이벤트 */
  loadMore = output<void>();

  /** 로딩 중 상태 (내부 관리) */
  private loadingInternal = signal(false);

  /** 로딩 표시 여부 */
  showLoading = computed(
    () => this.loadingInternal() || this.isLoading()
  );

  @HostListener('window:scroll')
  onScroll() {
    if (this.loadingInternal() || this.isLoading() || !this.hasMore()) return;

    const scrollPosition = window.innerHeight + window.scrollY;
    const documentHeight = document.documentElement.scrollHeight;

    if (scrollPosition >= documentHeight - this.threshold()) {
      this.loadingInternal.set(true);
      this.loadMore.emit();

      // 로딩 상태 자동 해제 (외부에서 관리하지 않는 경우를 위해)
      setTimeout(() => {
        this.loadingInternal.set(false);
      }, 500);
    }
  }
}
